<template>
    <img
        v-if="signature?.url"
        :src="signature.url"
        alt=""
        class="form-submission-card--signature img-fluid"
    >
</template>

<script>
export default {
    name: "SubmissionInlineSignature",
    props: {
        signature: {
            type: Object,
            required: true
        }
    },
}
</script>
